<template>
  <el-dialog :visible.sync="formModalShow" :title="'Ottley Sale'" @closed="$emit('close');" width="40%">
    <div class="row" slot="title" style="border-bottom: 1px solid #dddddd">
      <div class="col-12">
        <div class="p-2 my-auto d-flex justify-content-between align-self-center">
          <h4 class="m-0 pt-1">Ottley Sale</h4>
          <div class="my-auto d-flex justify-content-between mr-2">
            <circle-number-indicator :number="'1'" :active="statusCard == 1" />
            <circle-number-indicator :number="'2'" :active="statusCard == 2" />
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex justify-content-between align-items-center" v-loading="loading" v-if="statusCard == 1">
      <div class="col-12">
        <div class="row">
          <div class="col-4">Producer</div>
          <div class="col-8 py-1">
            {{ initial_business.name }}
          </div>
        </div>
        <div class="row">
          <div class="col-4">Sale Type <span class="required-flag">*</span></div>
          <div class="col-8 py-1">
            <el-select class="input-group" v-model="sale.type_id" placeholder="Select Region" clearable
              :class="[{ 'is-invalid': form.errors.has('type_id') }]">
              <el-option v-for="salesType in salesTypes" :key="salesType.id" :label="salesType.name"
                :value="salesType.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-4">Advised Settlement Date</div>
          <div class="col-8 py-1">
            <el-date-picker v-model="sale.confirmed_settlement_date" value-format="yyyy-MM-dd" format="dd/MM/yyyy"
              type="date" class="w-100" placeholder="Pick a day"></el-date-picker>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-right py-1">
            <el-button class="action-btn" @click="statusCard = 2" type="primary"
              :disabled="!sale.type_id">Next</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex justify-content-between align-items-center" v-loading="loading" v-if="statusCard == 2">
      <div class="col-12 row" v-if="sale.type_id == 1">
        <div class="col-12">
          <div class="row">
            <div class="col-4">Buyers Name</div>
            <div class="col-8 py-1">
              <input class="form-control" v-model="sale.purchaser_name"
                :class="[{ 'is-invalid': form.errors.has('purchaser_name') }, 'form-control']" />
            </div>
          </div>
          <div class="row">
            <div class="col-4">End Market <span class="required-flag">*</span></div>
            <div class="col-8 py-1">
              <el-select class="w-100" v-model="sale.end_market_id" placeholder="Select Market">
                <el-option v-for="item in endMarkets" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </div>
          </div>
          <div class="row">
            <div class="col-4">Total number of head <span class="required-flag">*</span></div>
            <div class="col-8 py-1">
              <currency-input class="w-100" :currency="null" :precision="0" v-model="sale.number_of_head"
                :class="[{ 'is-invalid': form.errors.has('number_of_head') }, 'form-control']" />
            </div>
          </div>
          <div class="row">
            <div class="col-4">Advised Sale Amount</div>
            <div class="col-6 py-1">
              <currency-input :disabled="sale.not_applicable" class="w-100" :currency="null" :precision="2"
                v-model="sale.value" />
            </div>
            <div class="col-2 my-auto">

              <el-tooltip class="item ml-2" effect="dark"
                content="Tick this option if 'Advised Sale Amount' is not applicable." placement="top-start">
                <el-checkbox class="w-25 my-auto" style="font-size:20px" v-model="sale.not_applicable"
                  :checked="!!sale.not_applicable">N/A</el-checkbox>
              </el-tooltip>
            </div>
          </div>
          <div class="row">
            <div class="col-4">Average Weight</div>
            <div class="col-8 py-1">
              <currency-input class="w-100" :currency="null" :precision="2" v-model="sale.average_weight" />
            </div>
          </div>
          <div class="row">
            <div class="col-4">Sales Summary CSV <span class="required-flag">*</span></div>
            <div class="col-8 py-1">
              <el-upload action ref="sale_summary_csv" :file-list="fileListSaleSummaryCsv"
                :on-change="handleUploadSaleSummaryCsv" :multiple="false" :auto-upload="false">
                <el-button size="small" type="primary">Select File</el-button>
              </el-upload>
            </div>
          </div>
          <div class="row">
            <div class="col-4">Sales Invoice</div>
            <div class="col-8 py-1">
              <el-upload action ref="sale_invoice" :file-list="fileListSaleInvoice" :on-change="handleUploadSaleInvoice"
                :multiple="false" :auto-upload="false">
                <el-button size="small" type="primary">Select File</el-button>
              </el-upload>
            </div>
          </div>
          <div class="row">
            <div class="col-4">Induction / Kill Sheet</div>
            <div class="col-8 py-1">
              <el-upload action ref="induction_data_kill_sheet" :file-list="fileListDataKillSheet"
                :on-change="handleUploadDataKilfileListDataKillSheet" :multiple="false" :auto-upload="false">
                <el-button size="small" type="primary">Select File</el-button>
              </el-upload>
            </div>
          </div>

        </div>
      </div>
      <div class="col-12 row" v-else>
        <div class="col-12">
          <div class="row">
            <div class="col-4">Total Deposit Amount <span class="required-flag">*</span></div>
            <div class="col-8 py-1">
              <currency-input class="w-100" :currency="null" :precision="0" v-model="sale.deposit_amount"
                :class="[{ 'is-invalid': form.errors.has('deposit_amount') }, 'form-control']" />
            </div>
          </div>
          <div class="row pt-3">
            <div class="col-4">Description</div>
            <div class="col-8 py-1">
              <el-input type="textarea" class="v-100" :rows=3 v-model="sale.description"></el-input>
            </div>
          </div>
          <div class="row">
            <div class="col-4">Payment Advice Document</div>
            <div class="col-8 py-1">
              <el-upload action ref="induction_data_kill_sheet" :file-list="fileListPaymentAdvice"
                :on-change="handleUploadPaymentAdviceDoc" :multiple="false" :auto-upload="false">
                <el-button size="small" type="primary">Select File</el-button>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 row mt-2">
        <div class="col-12 text-right py-1">
          <el-button class="action-btn" @click="statusCard = 1" type="primary">Previous</el-button>
          <el-button class="action-btn" @click="onSubmit" type="primary">Submit</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import EndMarket from "../../../modelsPortal/EndMarket";
import Sale from "../../../modelsPortal/Sale";
import Business from "../../../modelsPortal/Business";
import Form from "form-backend-validation";
export default {
  props: {
    initial_business: {
      type: Object,
    },
    regions: {
      type: Array,
    },
  },
  data() {
    return {
      formModalShow: true,
      form: new Form(),
      loading: false,
      salesTypes: [
        {
          'id': 2,
          'name': 'Deposit'
        },
        {
          'id': 1,
          'name': 'Livestock Sale'
        }
      ],
      endMarkets: [],
      sale: {
        type_id: null,
        confirmed_settlement_date: null,
        purchaser_name: null,
        end_market_id: null,
        number_of_head: null,
        value: null,
        average_weight: null,
        not_applicable: false,
        deposit_amount: null,
        description: null,
      },
      fileListSaleInvoice: [],
      fileListPaymentAdvice: [],
      fileListDataKillSheet: [],
      fileListSaleSummaryCsv: [],
      statusCard: 1,
      form: new Form(),
    }
  },
  created() {
    this.getEndMarkets();
  },
  methods: {
    onSubmit: function () {
      this.loading = true;

      let form_data = new FormData();
      // build form data
      for (const [key, value] of Object.entries(this.sale)) {
        if (value)
          form_data.append(key, value);
      }

      this.sale.payment_advice_doc = null;
      this.sale.sale_summary_csv = null;
      this.sale.sale_invoice = null;
      this.sale.induction_data_kill_sheet = null;

      if (this.$refs.payment_advice_doc && this.$refs.payment_advice_doc.fileList.length > 0) form_data.append('payment_advice_doc', this.$refs.payment_advice_doc.fileList[0].raw);
      if (this.$refs.sale_summary_csv && this.$refs.sale_summary_csv.fileList.length > 0) form_data.append('sale_summary_csv', this.$refs.sale_summary_csv.fileList[0].raw, this.$refs.sale_summary_csv.fileList[0].name);
      if (this.$refs.sale_invoice && this.$refs.sale_invoice.fileList.length > 0) form_data.append('sale_invoice', this.$refs.sale_invoice.fileList[0].raw);
      if (this.$refs.induction_data_kill_sheet && this.$refs.induction_data_kill_sheet.fileList.length > 0) form_data.append('induction_data_kill_sheet', this.$refs.induction_data_kill_sheet.fileList[0].raw);

      axios
        .post(
          `/api/v2/portal/businesses/${this.initial_business.id}/sales`,
          form_data,
          {
            headers: { "content-type": "multipart/form-data" }
          }
        )
        .then(res => {
          this.$message.success('Successfully saved!');
          this.$emit('close');
        })
        .catch(errors => {
          var errorText = "";
          _.forEach(errors.response.data.errors, function (value) {
            errorText += "" + value + " ";
          });
          this.$message({
            type: "error",
            message: errorText
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getEndMarkets() {
      new EndMarket().where('is_active', true).get().then((result) => {
        this.endMarkets = result;
      }).catch((err) => {

      });
    },
    handleUploadSaleSummaryCsv(file) {
      this.fileListSaleSummaryCsv = [file];
    },
    handleUploadSaleInvoice(file) {
      this.fileListSaleInvoice = [file];
    },
    handleUploadDataKilfileListDataKillSheet(file) {
      this.fileListDataKillSheet = [file];
    },
    handleUploadPaymentAdviceDoc(file) {
      this.fileListPaymentAdvice = [file];
    },
  },
}
</script>
<style>
.required-flag {
  color: red;
  font-size: 18px;
}
</style>